<template>
  <div class="page-root">
    <!-- 背景装饰 -->
    <div class="bg-deco bg-deco-green" />
    <div class="bg-deco bg-deco-gold" />

    <div class="page-wrap">
      <!-- 顶部导航 -->
      <div class="top-bar">
        <button class="back-btn" @click="goBack">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7" /></svg>
          <span>返回</span>
        </button>
        <span class="top-divider" />
        <span class="top-title">医生认证</span>
      </div>

      <div class="page-grid">
        <!-- 右栏 - 内容区 -->
        <div class="main-content">
          <!-- 基础信息 -->
          <section class="card-section">
            <div class="card-header">
              <div>
                <h2 class="card-title">基础信息</h2>
                <p class="card-desc">用于医生身份核验与平台资质展示</p>
              </div>
              <span class="card-badge">中医健康服务</span>
            </div>

            <div class="info-grid">
              <div v-for="item in infoRows" :key="item.label" class="info-item">
                <div class="info-label">{{ item.label }}</div>
                <div class="info-value">{{ item.value }} <span v-if="item.mark" class="star-mark">{{ item.mark }}</span></div>
              </div>
            </div>
          </section>

          <!-- 行医资格证 -->
          <section class="card-section">
            <div class="card-header">
              <div>
                <h2 class="card-title">行医资格证</h2>
                <p class="card-desc">证件图片将用于平台资质合规审核</p>
              </div>
              <button class="view-btn" @click="certVisible = true">查看原图</button>
            </div>

            <div class="cert-content">
              <div class="cert-desc">
                <p>当前行医资格证编号已录入，证件图片可用于后续处方服务、医师认证展示与平台合规留存。</p>
                <div class="cert-meta">
                  <div class="cert-meta-item">
                    <div class="meta-label">证件编号</div>
                    <div class="meta-value">{{ info.doctorCertNo }}</div>
                  </div>
                </div>
              </div>
              <div class="cert-thumb" @click="certVisible = true">
                <img v-if="info.doctorCertImageUrl" :src="info.doctorCertImageUrl" alt="行医资格证" />
                <div v-else class="cert-placeholder">
                  <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="#20863F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><path d="M21 15l-5-5L5 21" /></svg>
                  <span>暂无证件图片</span>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>

    <!-- 大图弹窗 -->
    <el-dialog :visible.sync="certVisible" title="行医资格证" width="620px" custom-class="cert-dialog" append-to-body>
      <img v-if="info.doctorCertImageUrl" :src="info.doctorCertImageUrl" class="cert-full" alt="行医资格证" />
      <div v-else class="no-cert">暂无证件图片</div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        info: {},
        fromPath: '',
        certVisible: false
      }
    },
    computed: {
      infoRows() {
        if (!this.info || !this.info.doctorName) return [];
        return [
          { label: "医生姓名", value: this.info.doctorName, mark: this.info.inheritor == 'Y' ? '★' : '' },
          { label: "医生性别", value: this.info.doctorSex == '0' ? '女' : '男', mark: '' },
          { label: "医生电话", value: this.info.doctorPhonNo, mark: '' },
          { label: "身份证号", value: this.info.idNo, mark: '' },
          { label: "行医资格证编号", value: this.info.doctorCertNo, mark: '' },
        ];
      }
    },
  created() {
      this.info = JSON.parse(this.$route.query.info)
      console.log(this.info)
    },
    methods:{
      goBack(){
          if(!this.utils.isEmptyStr(this.fromPath) && this.fromPath != '/'){
              this.$router.go(-1)
          }else{
              this.$router.replace('/')
          }
      },
    },
    beforeRouteEnter(to,from,next){
        next(vm =>{
            vm.fromPath = from.path
        })
    }
  }
</script>

<style scoped>
.page-root { position: relative; min-height: 100vh; background: #f4f9f5; font-family: 'Noto Sans SC', system-ui, sans-serif; color: #1a1a1a; overflow: hidden; }

/* 背景装饰 */
.bg-deco { position: absolute; border-radius: 50%; pointer-events: none; }
.bg-deco-green { left: -128px; top: 96px; width: 320px; height: 320px; background: rgba(42,122,75,0.05); filter: blur(60px); }
.bg-deco-gold { right: 0; top: 0; width: 384px; height: 256px; background: rgba(200,169,110,0.06); filter: blur(60px); }

.page-wrap { position: relative; max-width: 1200px; margin: 0 auto; padding: 48px 24px; }

/* 顶部导航 */
.top-bar { display: flex; align-items: center; gap: 16px; margin-bottom: 32px; }
.back-btn { display: inline-flex; align-items: center; gap: 8px; border: 1px solid rgba(42,122,75,0.25); background: #fff; border-radius: 9999px; padding: 10px 20px; font-size: 15px; font-weight: 500; color: #20863F; cursor: pointer; box-shadow: 0 1px 3px rgba(0,0,0,0.06); transition: background .2s; }
.back-btn:hover { background: #eef7f1; }
.top-divider { width: 1px; height: 20px; background: #cbd9d0; }
.top-title { font-size: 17px; font-weight: 600; color: #1f3327; }

/* 主体网格 */
.page-grid { display: grid; grid-template-columns: 1fr; gap: 32px; align-items: start; max-width: 960px; margin: 0 auto; }

/* 右栏卡片 */
.main-content { display: flex; flex-direction: column; gap: 24px; }
.card-section { background: #fff; border: 1px solid #e0ebe4; border-radius: 24px; padding: 32px; box-shadow: 0 1px 4px rgba(0,0,0,0.04); }
.card-header { display: flex; align-items: flex-start; justify-content: space-between; border-bottom: 1px solid #edf2ee; padding-bottom: 20px; margin-bottom: 20px; gap: 16px; }
.card-header > div { text-align: left; }
.card-title { font-size: 22px; font-weight: 700; color: #123b25; margin: 0; text-align: left; }
.card-desc { font-size: 14px; color: #718077; margin: 4px 0 0; text-align: left; }
.card-badge { display: inline-flex; align-items: center; background: #f4f9f5; border-radius: 9999px; padding: 8px 16px; font-size: 14px; font-weight: 500; color: #20863F; white-space: nowrap; }

/* 信息网格 */
.info-grid { display: grid; grid-template-columns: 1fr; gap: 12px; }
.info-item { border: 1px solid #edf2ee; background: #fcfdfc; border-radius: 16px; padding: 16px 20px; }
.info-label { font-size: 14px; font-weight: 600; color: #66756b; }
.info-value { font-size: 18px; font-weight: 500; color: #18251d; margin-top: 6px; word-break: break-all; }
.star-mark { color: #b93b2f; font-size: 18px; }

/* 行医资格证区 */
.cert-content { display: grid; grid-template-columns: 1fr; gap: 24px; }
.cert-desc p { font-size: 14px; color: #55655b; line-height: 1.7; margin: 0 0 16px; text-align: left; }
.cert-meta { display: grid; grid-template-columns: 1fr; gap: 12px; max-width: 240px; }
.cert-meta-item { background: #f4f9f5; border-radius: 16px; padding: 16px; }
.meta-label { font-size: 13px; color: #718077; }
.meta-value { font-size: 16px; font-weight: 600; color: #123b25; margin-top: 4px; word-break: break-all; }

.cert-thumb { display: flex; align-items: center; justify-content: center; height: 180px; border: 1px solid #dfeae3; border-radius: 24px; background: linear-gradient(135deg, #f6fbff, #fff); box-shadow: inset 0 2px 6px rgba(0,0,0,0.03); cursor: pointer; overflow: hidden; transition: transform .25s, box-shadow .25s; }
.cert-thumb:hover { transform: translateY(-2px); box-shadow: 0 10px 24px rgba(42,122,75,0.14); }
.cert-thumb img { width: 100%; height: 100%; object-fit: contain; }
.cert-placeholder { display: flex; flex-direction: column; align-items: center; gap: 8px; color: #888; font-size: 13px; }

.view-btn { display: inline-flex; align-items: center; border: 1px solid rgba(42,122,75,0.3); background: transparent; border-radius: 9999px; padding: 8px 16px; font-size: 14px; font-weight: 600; color: #20863F; cursor: pointer; transition: background .2s; white-space: nowrap; }
.view-btn:hover { background: #f4f9f5; }

.cert-full { width: 100%; display: block; border-radius: 8px; }
.no-cert { text-align: center; padding: 40px; color: #999; font-size: 16px; }

@media (min-width: 992px) {
  .page-wrap { padding: 48px 32px; }
  .info-grid { grid-template-columns: 1fr 1fr; gap: 16px; }
  .cert-content { grid-template-columns: 1fr 260px; align-items: center; }
  .cert-thumb { height: 176px; }
}

@media (max-width: 768px) {
  .page-wrap { padding: 24px 16px; }
  .card-section { padding: 20px; border-radius: 20px; }
  .card-header { flex-direction: column; gap: 8px; }
  .card-title { font-size: 20px; }
  .info-grid { grid-template-columns: 1fr; }
  .cert-content { grid-template-columns: 1fr; }
  .cert-thumb { height: 220px; }
  .top-bar { margin-bottom: 24px; }
}

@media (max-width: 480px) {
  .back-btn { padding: 8px 14px; font-size: 14px; }
  .top-title { font-size: 15px; }
  .info-value { font-size: 16px; }
  .view-btn { width: 100%; justify-content: center; }
}
</style>

<style>
.cert-dialog { border-radius: 18px; }
.cert-dialog .el-dialog__body { padding: 16px; }
</style>
